import { render, staticRenderFns } from "./addOrEditDialog.vue?vue&type=template&id=637ea09f&scoped=true&"
import script from "./addOrEditDialog.vue?vue&type=script&lang=js&"
export * from "./addOrEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ea09f",
  null
  
)

export default component.exports